import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import AppBanner from "../../images/appBanners.png";
import PromoBanner from "../../images/promoBanner.png";
import TrendingBanner from "../../images/trendingbanner.png";
import FeaturedBanner from "../../images/featuredBanner.png";
import TopdealsBanner from "../../images/topDeals.png"

const AppSection = () => {
  const AppSectionDocs = {
    title: "App Sections",
    description: "Learn how to efficiently manage app sections.",
    sections: [
      {
        title: "Overview",
        content: "App sections are dedicated banners that promote products or display marketing content to customers.",
      },
  
      {
        title: "Sections",
        content: "Displays different types of banners and guidance on how to configure each.",
        subsections: [
          {
            title: "App Banner",
            content:
              "App Banners are visible to customers, displaying marketing content to drive engagement.",
            image: AppBanner,
            imageAlt: "Add app banner",
            imageCaption: "Figure 1: Comprehensive view of app banners",
            steps: [
              "Collection: Select the relevant collection this app banner will highlight.",
              "Image: Upload the banner image (recommended size: 1024x512 pixels).",
            ],
          },
          {
            title: "Promo Banner",
            content:
              "Promo Banners display products that are currently being promoted.",
            image: PromoBanner,
            imageAlt: "Add promo banner",
            imageCaption: "Figure 2: Comprehensive view of promo banners",
            steps: [
              "Screen: Choose where this banner will be displayed, such as on the Home or Discover screen.",
              "Image: Upload the banner image (recommended size: 1024x512 pixels).",
            ],
          },
          {
            title: "Trending",
            content: "Highlights products that are trending to increase visibility.",
            image: TrendingBanner,
            imageAlt: "Add trending banner",
            imageCaption: "Figure 3: Comprehensive view of trending banners",
            steps: [
              "Category: Select the product category to promote in this section.",
              "Product: Choose the product from the dropdown and save your selection.",
            ],
          },
          {
            title: "Featured Categories",
            content: "Highlights specific categories using distinct colors.",
            image: FeaturedBanner,
            imageAlt: "Add featured category banner",
            imageCaption: "Figure 4: Comprehensive view of featured categories banners",
            steps: [
              "Feature Color: Choose a color to represent the featured category.",
              "Select Category: Select the product category to feature and save.",
            ],
          },
          {
            title: "Top Deals",
            content: "Displays products marked as top deals for increased promotion.",
            image: TopdealsBanner,
            imageAlt: "Add top deals banner",
            imageCaption: "Figure 5: Comprehensive view of top deals banners",
            steps: [
              "Category: Select the category for products marked as top deals.",
              "Product: Choose the product to feature as a top deal.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...AppSectionDocs} />;
};

export default AppSection;
